import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';

import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';
import { BannerAppComponent } from "../../../components/banner-app/banner-app.component";

@Component({
  selector: 'error-500',
  standalone: true,
  imports: [FooterAppComponent, BannerAppComponent],
  templateUrl: './error-500.component.html',
  styleUrl: './error-500.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Error500Component implements OnInit {

  ngOnInit(): void { }

    volverInicio(): void {
    window.location.href = "https://www.sura.co/";
  }

}
